<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">
    Contents
  </div>
<div class="sgc-toc-level-1">
<a href="#/Text/RUTH_genpref">General preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/RUTH_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/RUTH_abbrev">Chief abbreviations</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/RUTH_intro">Introduction</a>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/RUTH_pt1" title="Link target outside of Sample"><span class="bold2">Part 1:</span></span> <span class="bold2">The tears</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch01#sigil_toc_id_1" title="Link target outside of Sample">1. Going away (1:1–7)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch02#sigil_toc_id_2" title="Link target outside of Sample">2. Coming home (1:8–22)</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/RUTH_pt2" title="Link target outside of Sample"><span class="bold2">Part 2:</span></span> <span class="bold2">The wings of refuge</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch03#sigil_toc_id_3" title="Link target outside of Sample">3. Grace and gratitude (2:1–13)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch04#sigil_toc_id_4" title="Link target outside of Sample">4. A place in the family (2:14–23)</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/RUTH_pt3" title="Link target outside of Sample"><span class="bold2">Part 3:</span></span> <span class="bold2">The kinsman-redeemer</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch05#sigil_toc_id_5" title="Link target outside of Sample">5. The levir and the goel</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch06#sigil_toc_id_6" title="Link target outside of Sample">6. Faith active in love (3:1–18)</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/RUTH_pt4" title="Link target outside of Sample"><span class="bold2">Part 4:</span></span> <span class="bold2">The redemption and the joy</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch07#sigil_toc_id_7" title="Link target outside of Sample">7. Love beyond law (4:1–12)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_ch08#sigil_toc_id_8" title="Link target outside of Sample">8. We have a history (4:13–22)</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/RUTH_ch09" title="Link target outside of Sample">‘The Lord be with you’</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/RUTH_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_OT" title="Link target outside of Sample">The Bible Speaks Today: Old Testament series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/RUTH_NT" title="Link target outside of Sample">The Bible Speaks Today: New Testament series</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/author" title="Link target outside of Sample">About the Author</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/IVPtbs" title="Link target outside of Sample">IVP Academic Textbook Selector</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RUTH_contents.vue?27dc0f82